<template>
  <div>
    <div class="content-header row">
      <div class="content-header-left col-md-12 col-12 mb-2">
        <h3 class="content-header-title">Transaction History</h3>
      </div>
    </div>
    <div class="content-body">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-content">
              <div class="card-collapse">
                <div class="card mb-0 faqs">
                  <div class="card" v-for="transaction in transactions" v-bind:key="transaction.id">

                    <div class="card-header">
                      <h5 class="mb-0">
                        <button class="btn btn-link" data-toggle="collapse" :data-target="'#collapse-' + transaction.id"  aria-expanded="false">{{ucfirst (transaction.category)}} {{symbol (transaction)}} R{{amount (transaction)}} ({{prettyDate (transaction.createdate)}})</button>
                      </h5>
                    </div>

                    <div v-bind:id="'collapse-' + transaction.id" class="collapse">
                      <div class="card-body">
                        Date: <strong>{{transaction.createdate}}</strong><br />
                        Name: <strong>{{transaction.name}}</strong><br />
                        Reference: <strong>{{transaction.reference}}</strong>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'history',
  data: function () {
    return {
      transactions: []
    }
  },
  mounted: function () {
    var that = this

    $.ajax({
      beforeSend: function (xhr) {
        $.showLoading()
        if (window.localStorage.getItem('token')) {
          xhr.setRequestHeader('Authorization', window.localStorage.getItem('token'))
        }
      },
      complete: function () {
        $.hideLoading()
      },
      url: this.$config.apiUrl + 'wallet/wallet_transactions',
      type: 'post',
      success: function (data) {
        that.transactions = data.data
      }
    })
  },
  methods: {
    ucfirst: function (category) {
      return category.charAt(0).toUpperCase() + category.slice(1)
    },
    symbol: function (transaction) {
      if (transaction.debit === '0.00') {
        return '-'
      } else {
        return '+'
      }
    },
    amount: function (transaction) {
      if (transaction.debit === '0.00') {
        return transaction.credit
      } else {
        return transaction.debit
      }
    },
    prettyDate: function (createdate) {
      var dateArry = createdate.split(' ')
      return dateArry[0]
    }
  }

}
</script>
